import React, { FC, ReactNode } from 'react';

interface IComponentProps {
  selectedCount: number;
  count: number;
  children: ReactNode;
  translateYOffsetPx?: number;
}

export const FloatingActionBar: FC<IComponentProps> = ({ selectedCount, count, children, translateYOffsetPx = 0 }) => {
  if (!selectedCount) {
    return null;
  }

  return (
    <div className="floating-action-bar" style={{ transform: `translateY(calc(-${translateYOffsetPx}px - 40px))` }}>
      <div className="floating-action-bar__container">
        <div className="px-4 py-3">
          <span className="ff-semibold fs-m color-white">{selectedCount}</span>
          <span className="f-regular fs-s color-grey"> из </span>
          <span className="ff-semibold fs-m color-white">{count}</span>
          <span className="ff-regular fs-s color-grey"> выбрано</span>
        </div>

        {children}
      </div>
    </div>
  );
};
